import { useEffect, useState } from "react";

interface Ozellikler {
  ad: string;
  token?: string | null;
  bilgiAdresi?: string;
  /** Ayarlarda yeni kaydın hemen görüntülenmesi için doğrudan medya yolu. */
  medyaAdresi?: string | null;
  boyut?: number;
  adiGoster?: boolean;
}

export function OkulLogosu(ozellikler: Ozellikler) {
  // Okul/oturum değişiminde önceki okulun görüntüsü bir kare bile kalmaz.
  return <Logo key={`${ozellikler.bilgiAdresi}:${ozellikler.token}:${ozellikler.medyaAdresi}`} {...ozellikler} />;
}

function Logo({
  ad,
  token,
  bilgiAdresi = "/api/v1/okul/marka",
  medyaAdresi,
  boyut = 32,
  adiGoster = false,
}: Ozellikler) {
  const [goruntu, setGoruntu] = useState<string | null>(null);
  const [okulAdi, setOkulAdi] = useState(ad);

  useEffect(() => {
    const kontrol = new AbortController();
    let objeUrl: string | null = null;
    let sonAdres: string | null = null;
    let mesgul = false;
    const headers: HeadersInit = token ? { Authorization: `Bearer ${token}` } : {};

    const yenile = async () => {
      if (mesgul) return;
      mesgul = true;
      try {
        const secenek = {
          headers,
          credentials: "same-origin" as const,
          signal: AbortSignal.any([kontrol.signal, AbortSignal.timeout(8000)]),
        };
        let adres = medyaAdresi;
        if (adres === undefined) {
          const yanit = await fetch(bilgiAdresi, secenek);
          if (!yanit.ok) throw new Error("Okul bilgisi alınamadı.");
          const bilgi = await yanit.json() as { ad: string; logo_adresi: string | null };
          adres = bilgi.logo_adresi;
          setOkulAdi(bilgi.ad);
        }
        if (!adres) {
          setGoruntu(null);
          if (objeUrl) URL.revokeObjectURL(objeUrl);
          objeUrl = null;
          sonAdres = null;
          return;
        }
        if (adres === sonAdres) return;
        const yanit = await fetch(adres, secenek);
        if (!yanit.ok) throw new Error("Logo alınamadı.");
        const blob = await yanit.blob();
        if (kontrol.signal.aborted) return;
        if (objeUrl) URL.revokeObjectURL(objeUrl);
        objeUrl = URL.createObjectURL(blob);
        sonAdres = adres;
        setGoruntu(objeUrl);
      } catch {
        // Ağ kesildiğinde mevcut logo kalır; logo olmaması paneli engellemez.
      } finally {
        mesgul = false;
      }
    };
    void yenile();
    const sayac = window.setInterval(() => void yenile(), 60_000);
    window.addEventListener("focus", yenile);
    window.addEventListener("online", yenile);
    window.addEventListener("kantin:okul-logosu-degisti", yenile);
    return () => {
      kontrol.abort();
      window.clearInterval(sayac);
      window.removeEventListener("focus", yenile);
      window.removeEventListener("online", yenile);
      window.removeEventListener("kantin:okul-logosu-degisti", yenile);
      if (objeUrl) URL.revokeObjectURL(objeUrl);
    };
  }, [bilgiAdresi, medyaAdresi, token]);

  return (
    <span className="inline-flex min-w-0 items-center gap-2" title={okulAdi}>
      <span
        className="inline-flex shrink-0 items-center justify-center overflow-hidden rounded-md bg-kagit-2 text-xs font-satir text-murekkep"
        style={{ width: boyut, height: boyut }}
      >
        {goruntu ? (
          <img src={goruntu} alt={`${okulAdi} logosu`} width={boyut} height={boyut}
            className="h-full w-full bg-white object-contain p-0.5" onError={() => setGoruntu(null)} />
        ) : (
          <span aria-label={okulAdi}>{okulAdi.slice(0, 2).toLocaleUpperCase("tr")}</span>
        )}
      </span>
      {adiGoster && <span className="max-w-40 truncate text-sm font-satir">{okulAdi}</span>}
    </span>
  );
}
